import Cookies from 'universal-cookie';
import {ADD_MSG, REMOVE_MSG, CLEAR_ALL_MSG} from 'common/types';

const initialState = {
  messages: '',
};

const cookies = new Cookies();

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [ADD_MSG]: (state, action) => {
    return {
      ...state,
      messages: action.msg,
    };
  },
  [CLEAR_ALL_MSG]: (state) => {
    return {
      ...state,
      messages: '',
    };
  },
};

// ------------------------------------
// Reducer
// ------------------------------------
export default (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
};
